import React from 'react';
import FaqSection from 'components/FaqSection';
import GuideSection from 'components/GuideSection';
import GettingStarted from './guide/getting-started';
import SideBar from './guide/SideBar.js';
import Head from 'next/head';

function Guide(props) {
    return (
        <>
            <Head>
                <title>User Guide & Documentation | tabExtend</title>
                <meta
                    name="description"
                    content="Complete documentation and guides for using tabExtend. Learn how to manage tabs, organize workspaces, use keyboard shortcuts, and optimize your browser workflow."
                />
                <meta property="og:title" content="User Guide & Documentation | tabExtend" />
                <meta
                    property="og:description"
                    content="Complete documentation and guides for using tabExtend. Learn how to manage tabs, organize workspaces, use keyboard shortcuts, and optimize your browser workflow."
                />
                <link rel="canonical" href="https://www.tabextend.com/guide" />
            </Head>
            <GettingStarted />
        </>
    );
}

Guide.Layout = SideBar;

export default Guide;
